import React from 'react';
import { User, Mail, Phone, Calendar, AlertTriangle } from 'lucide-react';

const DuplicateMemberModal = React.memo(({ isOpen, onClose, onConfirm, onReject, existingMember, newMemberData }) => {
    if (!isOpen) return null;

    const renderField = (icon, label, existingValue, newValue) => (
        <div className="flex items-start text-sm">
            <div className="w-5 mr-2 text-gray-500">{icon}</div>
            <div className="flex-1">
                <strong className="font-semibold text-gray-800">{label}:</strong>
                <p className={`text-gray-600 ${existingValue !== newValue && newValue ? 'text-red-600 font-bold' : ''}`}>
                    {existingValue || <span className="italic text-gray-400">Não informado</span>}
                </p>
                {existingValue !== newValue && newValue && (
                    <p className="text-red-600 font-bold">Novo: {newValue}</p>
                )}
            </div>
        </div>
    );

    const existingFullName = existingMember.isSimple 
        ? `${existingMember.name} ${existingMember.lastName || ''}`.trim()
        : existingMember.name;
        
    const existingEmail = existingMember.isSimple 
        ? 'Cadastro Simplificado de Curso' 
        : existingMember.email;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-start z-50 p-4 overflow-y-auto">
            <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-2xl text-left my-auto">
                <div className="flex items-center text-orange-600 mb-4">
                    <AlertTriangle className="h-8 w-8 mr-3" />
                    <h3 className="text-xl font-bold">Possível Duplicidade Encontrada</h3>
                </div>
                <p className="text-sm text-gray-600 mb-6">
                    Encontramos um membro no sistema com dados muito parecidos. Por favor, verifique se não se trata da mesma pessoa antes de continuar.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-gray-50 p-4 rounded-lg border">
                        <h4 className="font-bold text-lg text-gray-800 mb-3">Cadastro Existente</h4>
                        <div className="space-y-2">
                            {renderField(<User size={16} />, "Nome", existingFullName)}
                            {renderField(<Mail size={16} />, "E-mail", existingEmail)}
                            {!existingMember.isSimple && renderField(<Phone size={16} />, "Telefone", existingMember.phone)}
                            {!existingMember.isSimple && renderField(<Calendar size={16} />, "Nascimento", existingMember.dob)}
                            {existingMember.isSimple && (
                                <div className="text-xs text-orange-600 bg-orange-50 border border-orange-200 p-2 rounded-md font-semibold">
                                    Este é um cadastro rápido de curso. Se você confirmar que é a mesma pessoa, o cadastro será promovido a Membro Completo e todo o histórico de presenças e notas será unificado.
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="bg-red-50 p-4 rounded-lg border border-red-200">
                        <h4 className="font-bold text-lg text-red-800 mb-3">Novo Cadastro</h4>
                        <div className="space-y-2">
                            {renderField(<User size={16} />, "Nome", existingFullName, newMemberData.name)}
                            {renderField(<Mail size={16} />, "E-mail", existingEmail, newMemberData.email)}
                            {renderField(<Phone size={16} />, "Telefone", existingMember.isSimple ? '' : existingMember.phone, newMemberData.phone)}
                            {renderField(<Calendar size={16} />, "Nascimento", existingMember.isSimple ? '' : existingMember.dob, newMemberData.dob)}
                        </div>
                    </div>
                </div>

                <p className="text-center font-semibold text-gray-800 mt-6 mb-4">Os registros acima são da mesma pessoa?</p>

                <div className="mt-6 flex justify-center gap-4">
                    <button onClick={() => onReject()} className="px-6 py-2 bg-red-600 text-white font-semibold rounded-md hover:bg-red-700">
                        Não, são pessoas diferentes
                    </button>
                    <button onClick={() => onConfirm()} className="px-6 py-2 bg-green-600 text-white font-semibold rounded-md hover:bg-green-700">
                        Sim, é a mesma pessoa
                    </button>
                </div>
            </div>
        </div>
    );
});

export default DuplicateMemberModal;